import React from 'react'
import PropTypes from 'prop-types'
import "./dropdown.css"

export default class DropDown extends React.Component {
  render(){
    return(
      <li>
        {this.props.href ? 
          <a href = {this.props.href}>{this.props.name}</a> 
          : 
          <button onClick = {this.props.click}>{this.props.name}</button>
        }   
        {this.props.children}
      </li>
    )
  }
}

DropDown.propTypes = {
  href  : PropTypes.string,
  name  : PropTypes.string,
  click : PropTypes.func
}
